import { Block, Flex, Icon } from '@aloft/toolkit-sui';

import { useStreetViewStaticUrl } from '../../hooks/googleMaps/useStreetViewStaticUrl.ts';
import { ValuationTablePropertyHeaderProps } from './types.ts';

export const ValuationTablePropertyHeaderImage = ({
  photoUrl,
  latitude,
  longitude,
  address,
}: ValuationTablePropertyHeaderProps) => {
  const coordinates = latitude && longitude ? { latitude, longitude } : undefined;
  const streetViewStaticUrl = useStreetViewStaticUrl(!photoUrl, address, coordinates);

  return (
    <Block height="88px" width="88px" minWidth="88px">
      {photoUrl ? (
        <img
          alt="Property"
          height="100%"
          width="100%"
          src={photoUrl}
          style={{ height: '100%', width: '100%', objectFit: 'cover' }}
        />
      ) : (
        <Flex
          justifyContent="center"
          alignItems="center"
          height="100%"
          width="100%"
          backgroundColor="strokeDefault"
        >
          {streetViewStaticUrl ? (
            <img
              alt="Street View"
              height="100%"
              width="100%"
              src={streetViewStaticUrl}
              style={{ height: '100%', width: '100%', objectFit: 'cover' }}
            />
          ) : (
            <Icon icon="home-2" size="lg" color="strokeActive" />
          )}
        </Flex>
      )}
    </Block>
  );
};
